import {
  getPersonalInfoConfig,
  getPersonalInfoConfigFields,
} from 'app/pages/loanApplication/tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/PersonalInfo/PersonalInfo.config';
import _ from 'lodash';

const DEPENDENT_AGE_FIELD_ID = 'ageOfDependents';
const DEPENDENT_AGE_KEY_PREFIX = 'agesOfDependents';

const buildDependentsCountPath = entityId => `[${entityId}].dependents.count`;
const buildDependentAgesPath = entityId => `[${entityId}].dependents.agesOfDependents`;

const getDependentAgeFields = ({ entityId, dependentsCount }) =>
  getPersonalInfoConfig({ entityId, numberOfDependents: dependentsCount }).groups.flatMap(
    ({ fields }) => fields.filter(({ fieldId }) => fieldId === DEPENDENT_AGE_FIELD_ID),
  );

export const getBorrowerConfigFieldsForEntity = ({
  entityId,
  dependentsCount = 0,
  onDependentsCountChange = _.noop,
}) => ({
  ...getPersonalInfoConfigFields({ entityId, customOnChangeDependents: onDependentsCountChange }),
  [DEPENDENT_AGE_FIELD_ID]: getDependentAgeFields({ entityId, dependentsCount }),
});

export const getBorrowerDependentsCount = ({ formState, applicationData, borrowerId }) => {
  if (_.isNil(borrowerId)) {
    return 0;
  }

  const countPath = buildDependentsCountPath(borrowerId);
  const formCount = _.get(formState, countPath);
  const count = _.isUndefined(formCount) ? _.get(applicationData, countPath) : formCount?.value;

  return parseInt(count, 10) || 0;
};

const pickDependentAgesWithinCount = ({ ages, count }) =>
  _.pickBy(ages ?? {}, (__, key) => Number(key.slice(DEPENDENT_AGE_KEY_PREFIX.length)) < count);

export const buildDependentsCountChangeHandler =
  ({ entityId, formRef, setMultipleInForm, validateField, onCountChange = _.noop }) =>
  (__, option) => {
    const countPath = buildDependentsCountPath(entityId);
    const agesPath = buildDependentAgesPath(entityId);
    const countValue = option || '';
    const count = parseInt(option?.value, 10) || 0;

    setMultipleInForm({
      [countPath]: countValue,
      [agesPath]: pickDependentAgesWithinCount({
        ages: _.get(formRef.current, agesPath),
        count,
      }),
    });
    onCountChange(count);
    validateField(countPath, countValue);
  };
